<div class="m-4">
  <h2 class="mb-4" i18n="@@approve-driveorder.approve">Godkänn</h2>
  <p class="mb-5" i18n="@@approve-driveorder.confirm">Bekräfta att du godkänner utfallet på körordern.</p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@approve-driveorder.cancel">Avbryt</button>
    <button class="btn btn-primary btn-min-width" id="approveBtn" type="button" (click)="approve()" [disabled]="buttonsDisabled" i18n="@@approve-driveorder.approve">Godkänn</button>
  </div>
</div>
